<template>
  <div class="bg-white border-round mapToolbox p-buttonset p-buttonset-vertical" style="width:30px">
    <InputNumber class="zoom-control"
                 v-model="zoom"
                 showButtons
                 buttonLayout="vertical"
                 decrement-button-class="p-button-secondary p-button-sm"
                 min="0" max="22"
                 increment-button-class="p-button-secondary p-button-sm"
                 incrementButtonIcon="map-icon-zoom-in"
                 decrementButtonIcon="map-icon-zoom-out"
                 autofocus="false"
                 @update:model-value="applyZoomLevel"/>

  </div>
</template>
<script lang="ts">

import {defineComponent, PropType} from "vue";

import Button from "primevue/button";
import {MapController} from "@/js/Map/map-controller";
import InputNumber from "primevue/inputnumber";

export default defineComponent({
  name: 'MapZoomControl',
  components: {Button, InputNumber},
  props: {
    mapController: {
      type: Object as PropType<MapController>,
      required: true,
    },
  },
  mounted() {
    this.zoom = Math.floor(this.mapController.mapInstance.getZoom());
    this.mapController.mapInstance.on('zoom', () => {
      this.zoom = Math.floor(this.mapController.mapInstance.getZoom());
      this.$forceUpdate();
    })
  },

  methods: {
    applyZoomLevel() {
      this.mapController.mapInstance.flyTo({zoom: this.zoom, maxDuration: 300})
    }
  },
  data() {
    return {
      zoom: 0
    }
  },

})
</script>
<style lang="scss">
.zoom-control {
  width: 30px;

  .map-icon-zoom-in {
    background-image: url(/icons/toolbox/zoom-in.svg);
    width: 18px;
    height: 18px;
    background-size: 18px 18px;
  }

  .map-icon-zoom-out {
    background-image: url(/icons/toolbox/zoom-out.svg);
    width: 18px;
    height: 18px;
    background-size: 18px 18px;
  }

  .p-inputtext {
    font-size: 13px !important;
    padding: 0 !important;
  }

  .p-button {
    width: 30px !important;
  }

  .p-button-icon {
    font-size: 13px !important;
  }
}

html.dark {
  .zoom-control {
    .p-inputtext {
      border: none !important;
    }

    .map-icon-zoom-in, .map-icon-zoom-out {
      filter: invert(100%);
    }
  }
}
</style>
